import { DataGrid } from "devextreme-react";
import { Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel } from "devextreme-react/data-grid";
import { IStockReservationTransactionRecordDto } from "../../../dtos/transactions/IStockReservationTransactionRecordDto";

interface IProps {
  items: IStockReservationTransactionRecordDto[];
}

export const StockReservationTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column width={150} dataField="period" dataType={"datetime"} caption="Period" sortOrder={"asc"} sortIndex={1} />
          <Column width={150} dataField="documentId" dataType={"string"} caption="Document " />
          <Column width={150} dataField="movementType" dataType={"number"} caption="Movement Type" />
          <Column width={150} dataField="employeeId" dataType={"string"} caption="Employee" />
          <Column width={150} dataField="accrualMonth" dataType={"datetime"} caption="Accrual Month" />
          <Column width={150} dataField="warehouseId" dataType={"string"} caption="Warehouse" />
          <Column width={150} dataField="productId" dataType={"string"} caption="ProductP" />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
